import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RefundPolicyRoutingModule } from './refund-policy-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RefundPolicyRoutingModule
  ]
})
export class RefundPolicyModule { }
